const requisitionInputsGroupsById = [
  "requisitionsInformation",
  "patientInformation",
  "patientHistory",
];

export default requisitionInputsGroupsById;
